import React from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'
import { useParams } from 'react-router-dom'

const NotFound = () => {
  let { pid } = useParams()
  let myNotFoundJson = {
    ...templateJson,
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>重新填寫此問卷：</h4> <a href=${
      window.location.origin + '/' + pid.toLowerCase()
    }>${
      window.location.origin + '/' + pid.toLowerCase()
    }</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${
      window.location.origin
    }>${window.location.origin}</a>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: "<h2 style='text-align: center'>圖片格式錯誤，請重新上傳</h2>",
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }
  const survey = new Model(myNotFoundJson)

  return <Survey model={survey} />
}

export default NotFound
